import React from 'react';
import styled, {ThemeProps} from 'styled-components';
import {createSelector} from 'reselect';

// THEME
import {Theme} from '../../../../../stories/theme/types';

// HOOKS
import {useSelector} from 'react-redux';

// ICONS
// import CheckedIcon from '../../../../../stories/Icons/CheckedIcon';
import RoundedCheckbox from '../../../../../stories/Icons/RoundedCheckbox';

// COLOR Palette
import {defaultTheme} from 'build-theme/src/build-theme';
// SELECTORS

import {hotelPolicyDataSelector} from '../../selectors';

// CONFIG
import {detailsNavigationIds} from '../../details.config';
import {detailsAPIEndPoints} from '../../../../config/api-config';
import {FetchStatusType} from '../../redux/types';

const PolicyStyledWrapper = styled.div(
  props => `

  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.xxlarge};
`,
);

const PolicyHeaderStyled = styled.div(
  props => `

  border-bottom: 0.1rem solid ${props.theme.colors.grey.grey15};
  padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l25};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;

`,
);

const PolicyHeaderTextStyled = styled.div(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.large.font20};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);

const PolicyListBlock = styled.ul(
  props => `
  // background-color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.large.l25};
  // border-radius: ${props.theme.misc.borderRadius.large};
  // border-top-left-radius:0;
  // border-top-right-radius:0;
`,
);

const PolicyListItemTextStyled = styled.li(
  (props: ThemeProps<Theme>) => `
  display: flex;
  font-size: ${props.theme.font.large.font16};
  line-height: 1.4;
  list-style-type: none;
  padding: 0 0 ${props.theme.spacing.large.l15} 0;
`,
);

const ErrorText = styled(PolicyListItemTextStyled)(
  props => `
  color: ${props.theme.colors.red.base}
`,
);

const staticCheckedIconProps = {
  height: '20px',
  fill: defaultTheme.colors.grey.grey75,
};

const CheckedIconWrapperStyled = styled.span(
  props => `
  padding: 0 ${props.theme.spacing.large.l15} 0 0;
`,
);

const PolicyTextStyled = styled.span`
  /* margin-top: -4px; * to make for font deformalities - https://www.youtube.com/watch?v=jnV1u67_yVg */
`;

type HotelPolicyDataTypes = {
  // crystal: boolean,
  additional_hotel_policy: {
    'Hotel Policy': Array<any>;
  };
  hotelPolicy: string[];
};

const Policy = () => {
  const {hotelPolicyList, hotelPolicyError, hotelPolicyFetchStatus} = useSelector(
    hotelPolicyDataSelector,
  );

  /** review page also needs hotel policy, we get pax from there
   *  when this function will be fired from there. Keeping it static
   * for nowb.
  // const descblock = {input: {pax: ''}};
  // const {input = {pax: ''}} = descblock;
  // const {pax: paxFromDescblock = ''} = input;

  /**
   * we have to use the old format of pax (the one which hermes sends back in room flavors)
   *
   * FYI –
   *    OLD HERMES PAX LOGIC – <No of Rooms>-<Adults in one room><Adults in Other Room>…
   *    NEW HERMES PAX LOGIC – <No of Roooms>-<Total Number of Adults>-<Total Number of Children>…
   */

  // const finalPax = pax || paxFromDescblock || replaceLastHyphenWithUnderScore(roomString);

  if (!!hotelPolicyError || !hotelPolicyList.length) {
    return null;
  }

  return (
    <PolicyStyledWrapper id={detailsNavigationIds.hotelPolicies}>
      {/* POLICY HEADER */}
      <PolicyHeaderStyled>
        <PolicyHeaderTextStyled>Hotel Policies</PolicyHeaderTextStyled>
      </PolicyHeaderStyled>

      {/* POLICY BLOCK */}
      <PolicyListBlock>
        {/* LOADER */}
        {hotelPolicyFetchStatus === FetchStatusType.PENDING && (
          <PolicyListItemTextStyled>Loading Hotel Policy…</PolicyListItemTextStyled>
        )}

        {/* POLICY LIST */}

        {!!hotelPolicyList.length &&
          hotelPolicyList.map((policy: string) => (
            <PolicyListItemTextStyled key={policy}>
              <CheckedIconWrapperStyled>
                <RoundedCheckbox {...staticCheckedIconProps} />
              </CheckedIconWrapperStyled>

              <PolicyTextStyled>{policy}</PolicyTextStyled>
            </PolicyListItemTextStyled>
          ))}

        {/* 🐨 ENHANCEMENT:
          1. provide a retry button
          2. handle error.message. Need to ask
            from hotel policy api maintainers for
            different errors they throw

            NOTE: because 2. is not done, we are
            showing a very generic error message
        */}

        {/* ERROR */}
        {!!hotelPolicyError && <ErrorText>An Error Occured While Loading Hotel Policies</ErrorText>}
      </PolicyListBlock>
    </PolicyStyledWrapper>
  );
};

export default Policy;
